import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import gettext from 'js-utils/gettext';

import ValidationFormField from 'eventbrite_design_system/validationFormField/ValidationFormField';
import InputField from 'eventbrite_design_system/inputField/InputField';

import { shouldDisplayError } from 'js-utils/redux';

export default class EmailField extends PureComponent {
    static propTypes = {
        buttonClasses: PropTypes.string,
        submitFailed: PropTypes.bool,
        isStatic: PropTypes.bool,
    };

    render() {
        const { buttonClasses, isStatic } = this.props;

        // User are unable to login when the page is loading, due to "dynamic" style of the input.
        // When a loading state for LookUpForm component were implemented, we should remove this prop.
        const style = isStatic ? 'static' : 'dynamic';

        return (
            <div className={buttonClasses}>
                <ValidationFormField
                    name="email"
                    shouldDisplayError={shouldDisplayError}
                    v2={true}
                >
                    <InputField
                        id="email"
                        name="email"
                        label={gettext('Email address')}
                        type="email"
                        role="textbox"
                        style={style}
                    />
                </ValidationFormField>
            </div>
        );
    }
}
